import React from "react";
import AppBox from "@/components/AppBox";
import AppText from "@/components/AppText";
import Logo from "/public/images/logo.png";
import moment from "moment";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const isAgency = window.location.pathname.includes("login");

  return (
    <AppBox column center gap={8} className="min-h-screen overflow-hidden">
      {/* Logo Section */}
      <AppBox center>
        {isAgency ? (
          <AppText variant="h1" className="text-3xl font-bold text-gray-800">
            LSA Auto-Responder
          </AppText>
        ) : (
          <img src={Logo} alt="Website logo" className="h-16" />
        )}
      </AppBox>

      {/* Content Section */}
      <AppBox className="max-w-screen-sm px-4">
        {children}
      </AppBox>

      {/* Footer Section */}
      {!isAgency && (
        <AppBox center className="w-full text-center text-gray-500 text-sm">
          © {moment().format("YYYY")} LSArespond. All rights reserved.
        </AppBox>
      )}
    </AppBox>
  );
};

export default AuthLayout;